import { GET_SUBSCRIBE_PRICE_SCREEN_DATA } from '../actions/getSubscribePriceScreenActions';

export let allSubscribePriceScreenSelector =  (state: any) => {
    return state[GET_SUBSCRIBE_PRICE_SCREEN_DATA];
  };